import { BASE_MENU_HEAD, BASE_MENU_TAIL } from "./menuItems";

// Same shared entries as adminMenu, minus ADMIN_ONLY ("Control Panel Users").
const userMenu = [...BASE_MENU_HEAD, ...BASE_MENU_TAIL];

export default userMenu;
